import React from 'react';
import DetailBar from './components/DetailBar';
import DualAxisChart from '../../../../../shared/charts/DualAxisChart';
import { summaryScaleSessions } from '../../../utils/summaryScale';
import moment from 'moment';
import { Col, Row } from 'antd';
import SessionsTable from './components/SessionsTable';
import SessionDeviceBreakdown from './components/SessionDeviceBreakdown';
import { LoadingPage } from '../../../../../shared/LoadingPage';

const EditorialSessionsDetailsView = ({
  data,
  sessionsSummary={sessionsSummaryData},
  startDate,
  endDate,
  sessionsList,
  sessionsByDates,
  deviceBreakdown,
  changeSessionsDatePicker,
}) => {
  const { sessions, avgSessionDuration, pagesPerSession, sessionAttrPageViews} = sessionsSummary;
  const dropDownOptions = [
    { key: 'sessions', display: 'Sessions' },
    { key: 'totalSessionDuration', display: 'Total Session Duration' },
    { key: 'averageSessionDuration', display: 'Average Session Duration' },
    { key: 'pagesPerSession', display: 'Pages Per Session' },
  ];
  if (!data) return <LoadingPage />;

  return (
    <>
      <DetailBar
        sessionAttrPageViews={sessionAttrPageViews}
        startDate={startDate}
        endDate={endDate}
        sessions={sessions}
        averageSessionDuration={avgSessionDuration}
        pagesPerSession={pagesPerSession}
        loading={false}
        module="SESSIONS"
      />
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <DualAxisChart
            byDate={sessionsByDates || []}
            xAxis="date"
            options={dropDownOptions}
            defaultLeftYValue={dropDownOptions[0]}
            defaultRightYValue={dropDownOptions[1]}
            customScale={summaryScaleSessions}
            onDatePickerChange={({ data, dates, rangeKey }) => {
              changeSessionsDatePicker(dates);
            }}
            has6MonDisables={false}
            allTimeDateRange={[moment(startDate), moment(endDate)]}
          />
        </Col>
        <Col span={24}>
          <SessionDeviceBreakdown
            data={deviceBreakdown || null}
          />
        </Col>
        <Col xs={24}>
          <SessionsTable data={sessionsList || []} />
        </Col>
      </Row>
    </>
  );
};

export default EditorialSessionsDetailsView;
